import MemoryType from "../../service/memory/enum/MemoryType";
import LocalStorageHandler from "../../service/memory/handler/LocalStorageHandler";

export const getContext = () => {
  const localStorage = new LocalStorageHandler()
  const userJson = localStorage.read(MemoryType.USER)
  const teams = localStorage.read(MemoryType.TEAMS)
  const role = userJson?.jobTitle
  const teamIds = teams?.map(team => team.id) || [];
  let context = {
    organizationIdentifier: userJson?.organizationIdentifier,
    role: role?.replace("Demo ", ""),
    userIdentifier: userJson?.userIdentifier,
    teamIds: teamIds
  };
  return context;
};
